import React, { useEffect, useMemo, useState } from "react"
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import TableContainerV1 from "../../components/Common/TableContainerV1"
import { getSignupInquiryList } from "../../helpers/UAM/signInquiry.helper"


const TableActionsComponent = (rowData, roleName) => {
  const navigate = useNavigate();
  const navigateToSignupInquriy = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${roleName}/signup-inquiry/view?id=${encodeURIComponent(encryptedId)}`)
  };


  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToSignupInquriy(rowData.id)
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="edittooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}


const SignupInquiry = () => {

  document.title = "Dealer Inquiry List | DMS";

  const navigate = useNavigate();
  const [inquiryList, setInquiryList] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0, })
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({ column: "id", isAsc: false, optionalColumn: ['Action'], });

  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const columns = useMemo(
    () => [
      {
        Header: "Inquiry Number",
        accessor: "id",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Person Name",
        accessor: "personName",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Mobile Number",
        accessor: "phone",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Company Name",
        accessor: "companyName",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Status",
        accessor: "inquiryStatus",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? cellProps.value : ""
        },
      },
      {
        Header: "Action",
        Cell: cellProps => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData, roleName)
        },
      },
    ],
    []
  )

  useEffect(() => {
    getSignupInquiryList()
      .then((responseFromApi) => {
        if (responseFromApi.status && responseFromApi.code == 200) {
          setInquiryList(responseFromApi.data?.data);
          const { totalItems, totalPages, currentPage } = responseFromApi.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        }
      })
      .catch((err) => { console.log(err) })
  }, [])

  const handleCustomerClicks = () => {
    navigate(`/${roleName}/dealers/add`)
  }

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    setCurrentPage(page)
    getSignupInquiryList({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setInquiryList(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setInquiryList([])
        }
      })
      .catch(error => {
        console.log(error)
      })
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "", "id", "desc");
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Dealer Inquiry" breadcrumbItem="Dealer Inquiry List" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={inquiryList}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  sortOptions={sortingOptions}
                  searchHelperText={"Search by Person Name, Email, Company Name"}
                  handleClearSearch={handleClearSearch}
                  isGlobalFilter={true}
                  isAddDealerList={false}
                  handleSortColumn={handleSortColumn}
                  handleCustomerClick={handleCustomerClicks}
                  customPageSize={10}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default SignupInquiry
